import {
  DSAttendanceMonitoringType,
  DSAttendanceRuleRecurrence
} from '@/constants/ds-attendance.constants'

/** Q18 — janela padrão do app e do App Externo (horas corridas). */
export const APP_SEND_WINDOW_PLACEHOLDER = '48 (padrão)'

/**
 * Q18/§2.4 — placeholder da janela da FOLHA: o valor que o backend deriva quando o campo
 * fica vazio. Folha não diária = 30 dias; senão a MAIOR recorrência entre as regras
 * (mensal 30, quinzenal 15, semanal 7); sem regra, 7 (Q27).
 */
export function sheetSendWindowPlaceholder(
  monitoringType: DSAttendanceMonitoringType,
  recurrences: DSAttendanceRuleRecurrence[]
): string {
  if (monitoringType === DSAttendanceMonitoringType.NON_DAILY_SHEET) return '30 (folha não diária)'
  if (recurrences.includes(DSAttendanceRuleRecurrence.MONTHLY)) return '30 (mensal)'
  if (recurrences.includes(DSAttendanceRuleRecurrence.BIWEEKLY)) return '15 (quinzenal)'
  if (recurrences.includes(DSAttendanceRuleRecurrence.WEEKLY)) return '7 (semanal)'
  return '7 (padrão)'
}
